import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { NavController } from '@ionic/angular';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(
    private alertController: AlertController,
    private navCtrl: NavController,
    private http: HttpClient
  ) {}
private hasShownWeakSignalWarning = false;
  showHTTPError(error?: HttpErrorResponse) {
    let message: string;
    console.log( error)

    if (error?.status === 401) {
      message = `
        <p>The link you are using has expired.</p>
        <p>Please contact the agent who shared the link, or tap below to reach our support team on WhatsApp:</p>
        <p><a href="https://wa.me/27617241882" target="_blank"><b>+27 61 724 1882</b></a></p>
      `;
    } else {
      message = `
        <p>Something went wrong.</p>
        <p>We could not process your information at this moment.</p>
        <p>Please try again later.</p>
      `;
    }

    this.presentAlert(message);
  }
  showMemoryLimitError(msg: string) {
    this.presentAlert(msg)
  }

  showTokenValidationError(msg: string) {
    this.presentAlert(msg)
  }

  showCameraErrorAndGuidanceToEnableSettings() {
    var message = ""
    var steps = ""
    const agent = window.navigator.userAgent.toLowerCase()
    switch(this.platform) {
      case 'Android':
        message = "Camera not found in the device or not allowed the access. Please allow the access for the camera" + '<br/>'
        switch (agent != null) {
          case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
            steps = "Step 1: On your device, open the Chrome app." + '<br/>' + "Step 2: To the right of the address bar, tap More. Settings." + '<br/>' + "Step 3: Tap Site Settings.Tap Camera." + '<br/>' + "Step 4: Tap to turn the camera on or off."
            break
          case agent.indexOf('firefox') > -1:
            steps = "Open your device settings by tapping the Settings app on your device." + '<br/>' + "Step 2: Tap Apps & notifications (this might have a different label on your version of Android)." + '<br/>' + "Step 3: Tap Firefox. Tap Permissions." + '<br/>' + "Step 4: Tap Camera. Tap Allow."
            break
          case agent.indexOf('safari') > -1:
            break
          default:
        }
        message = message + steps
        break
      case 'iOS':
        message = "Camera not found in the device or not allowed the access. Please allow the access for the camera" + '<br/>'
        steps = "Step 1: On your device, open the Settings app." + '<br/>' + "Step 2: Please find Chrome in the list and turn on Camera Switch ON"
        switch (agent != null) {
          case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
            steps = "Step 1: On your device, open the Settings app." + '<br/>' + "Step 2: Please find Chrome in the list and turn on Camera Switch ON"
            break
          case agent.indexOf('firefox') > -1:
            steps = "Step 1: On your device, open the Settings app." + '<br/>' + "Step 2: Please find Firefox in the list and turn on Camera Switch ON"
            break
          case agent.indexOf('safari') > -1:
            steps = "Step 1: On your device, open the Settings app." + '<br/>' + "Step 2: Please find Safari in the list and tap" + '<br/>' + "Step 3: Please find camera option at the bottom and tap." + '<br/>' + "Step 4: Tap <b>Allow</b> or <b>Ask</b>."
            break
          default:
            break
        }
        message = message + steps
        break
      case 'unknown':
        message = "This application is only accessible in mobile browsers. Kindly switch to mobile browsers for better onboarding experience."
        break
      }
      this.presentAlert(message)
      this.navCtrl.navigateForward('/unauthorised');
  }
  showWeakSignalWarning() {
  if (this.hasShownWeakSignalWarning || sessionStorage.getItem('shown_weak_signal')) return;

  const message = `
    <p><b>Weak Signal Detected</b></p>
    <p>Your network connection appears to be weak or unstable. This may affect:</p>
    <ul>
      <li>Image or document uploads</li>
      <li>Biometric scanning or camera performance</li>
    </ul>
    <p>Please move to an area with better signal for a smoother experience.</p>
  `;

  this.hasShownWeakSignalWarning = true;
  sessionStorage.setItem('shown_weak_signal', 'true');  // ✅ store it for the session
  this.presentAlert(message);
}

  private async presentAlert(msg) {
    const alert = await this.alertController.create({
      header: '',
      subHeader: 'Error',
      message: msg,
      buttons: ['OK'],
    });

    await alert.present();
  }

  /**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
  get platform(): string {
    var userAgent = navigator.userAgent;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return "iOS";
    }

    return "unknown";
  }

  /*
  * REGULA ERROR HANDLING
  */
  showCameraErrorForRegula() {
    var message = "Camera is mandatory to access this onboarding." + '<br/>' + "Please make sure your device has the camera and you have allowed the access."
    this.presentAlert(message)
  }
}
